"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONBOARDING_PLANS = void 0;
exports.planOnboardsInInternalSetup = planOnboardsInInternalSetup;
exports.planCollectsBrandDocs = planCollectsBrandDocs;
/**
 * Onboarding plans and the two questions the gates keep asking of them.
 *
 * Mirrors the Prisma `OnboardingPlan` enum; the db package is not a dependency
 * here, so the values are repeated and pinned by a test on the backend side.
 */
exports.ONBOARDING_PLANS = [
    "ENTERPRISE_AUDIT",
    "FULL_CREATIVE",
    "FRAMEWORK_ONLY",
    "NEWFORM_ONE",
];
/**
 * The whole client onboarding is the internal setup wizard at `/onboarding`:
 * there is no client-intake route before it and no team review gate after it,
 * so `completedFrameworkClientIntake` is stamped true at provisioning and the
 * wizard's last step is what takes the org live.
 */
function planOnboardsInInternalSetup(plan) {
    return plan === "FRAMEWORK_ONLY" || plan === "NEWFORM_ONE";
}
/**
 * The onboarding asks the client for the full-service brand material (the
 * Creative Testing, Brand Deep Dive, Performance Deep Dive and Compliance docs)
 * and keeps a `FullServiceOnboarding` row to hold it. Full-creative clients
 * upload it on the way to team review; NewForm One clients upload it as a step
 * of the setup wizard, because creators work from the same material.
 */
function planCollectsBrandDocs(plan) {
    return plan === "FULL_CREATIVE" || plan === "NEWFORM_ONE";
}
